import React from "react";

const OfferContext = React.createContext({
    data: [],
    isLoaded: false,
    error: null,
    selectedCountries: [],
    setSelectedCountries: () => {}
})

export default OfferContext;